import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { IBaseEnumEntity } from '../../base/interfaces/IBaseEnumEntity';
import { DocumentType } from '../../models/documentType.model';
import { AttributeOption } from '../models/AttributeOption';
import { DocumentQuery } from '../models/DocumentQuery';

@Component({
  selector: 'app-search-query',
  templateUrl: './search-query.component.html',
  styleUrls: ['./search-query.component.css']
})
export class SearchQueryComponent implements OnInit {

  @Input() isNew = true;
  @Input() showSearchBox = true;
  @Input() isWizzard = false;
  @Input() indexes: IBaseEnumEntity[] = null;

  @Output() query = new EventEmitter<DocumentQuery>();
  @Output() newDocument = new EventEmitter();
  @Output() selectedType = new EventEmitter<DocumentType>();

  public form: FormGroup;
  public type: DocumentType;
  public autoOptions: Observable<AttributeOption[]>;

  constructor() { }

  ngOnInit() {
    this.form = new FormGroup({
      query: new FormControl(),
      typeId: new FormControl({value: null, disable: true}),
    });
    this.onSearch();
  }

  onSearch() {
    let query = this.form.controls['query'].value;
    if (!query) {
      query = null;
    }
    if (this.type) {
      const ret = new DocumentQuery(query, this.type.id) ;
      this.query.emit(ret);
    }
  }
  onNew() {
    this.newDocument.emit();
  }
  onWizard() {
    // wizard things
  }
  onTypeSelected(type: DocumentType) {
    console.log('onTypeSelected', type);
    if (type) {
      this.type = type;
      this.form.controls['typeId'].setValue(this.type.id);
      this.form.get('query').enable();
      this.autoOptions = of(
         this.type.attributes.map(attr => {
          return new AttributeOption(attr.id, attr.name);
        })
      );
      this.onSearch();
    } else {
      this.type = null;
      this.form.controls['typeId'].setValue(null);
      this.form.get('query').disable();
    }
    this.selectedType.emit(type);
  }
}
